import { render, staticRenderFns } from "./SelectOrderView.vue?vue&type=template&id=4619cd04&"
import script from "./SelectOrderView.vue?vue&type=script&lang=js&"
export * from "./SelectOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports